// Hooks / Node modules / Styles
import { motion } from "framer-motion";

// Reducers / Actions

// Utils / Functions
import { textVariant, fadeIn } from "src/utils/framer-motion/motion";

// Components

// Sub-Components
import ComponentContainer from "../ComponentContainer";
import ServiceCardGroup from "./com/ServiceCardGroup";

// Data / Images / Icons

function About() {
  return (
    <ComponentContainer
      title="Overview"
      subtitle="Introduction"
      description=" I'm a skilled software engineer with years of experience in various
        languages, and expertise in frameworks like React, Node.js, and
        Three.js. I'm a quick learner and collaborate closely with clients to
        create efficient, scalable, and user-friendly solutions that solve
        real-world problems. Let's work together to bring your ideas to life!"
    >
      <ServiceCardGroup />
    </ComponentContainer>
  );
}

export default About;
